<div class="each-page">
    <!-- Page Header -->
    <div class="page-header">
        <div class="page-header__content">
            <div class="page-left gap-2.5">
                <div class="page-icon">
                    <img
                        src="../assets/img/dashboard.svg"
                        class="h-8"
                        alt="Add difficulty level"
                    />
                </div>

                <div class="page-headings">
                    <h1>{{ pageTitle }}</h1>

                    <p *ngIf="pageSubtitle">
                        {{ pageSubtitle }}
                    </p>
                </div>
            </div>
        </div>

        <div class="page-header-right"></div>
    </div>

    <!-- Page Content -->
    <div class="page-content">
        <section class="course-table-card">
            <div class="create-page">
                <form
                    class="create-page__form"
                    
                    (ngSubmit)="submitDifficultyLevel()"
                    novalidate
                >
                    <!-- Name -->
                    <div class="create-page__group">
                        <label for="difficultyLevelName">
                            Name

                            <span class="create-page__required">
                                *
                            </span>
                        </label>

                        <div
                            class="create-page__control"
                            [class.create-page__control--invalid]="
                                isSubmitted &&
                                nameControl.invalid
                            "
                        >
                            <span class="create-page__control-icon">
                                <svg
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M4 20V10"
                                    ></path>

                                    <path
                                        d="M10 20V4"
                                    ></path>

                                    <path
                                        d="M16 20v-7"
                                    ></path>

                                    <path
                                        d="M22 20V7"
                                    ></path>
                                </svg>
                            </span>

                            <input
                                id="difficultyLevelName"
                                type="text"
                                formControlName="name"
                                placeholder="Enter difficulty level name"
                                autocomplete="off"
                            />
                        </div>

                        <p class="create-page__hint">
                            Enter a clear and recognizable
                            difficulty-level name.
                        </p>

                        <p
                            class="create-page__error"
                            *ngIf="
                                isSubmitted &&
                                nameControl.hasError(
                                    'required'
                                )
                            "
                        >
                            Difficulty-level name is required.
                        </p>

                        <p
                            class="create-page__error"
                            *ngIf="
                                isSubmitted &&
                                nameControl.hasError(
                                    'maxlength'
                                )
                            "
                        >
                            Difficulty-level name cannot exceed
                            100 characters.
                        </p>

                        <p
                            class="create-page__error"
                            *ngIf="
                                isSubmitted &&
                                nameControl.hasError(
                                    'pattern'
                                )
                            "
                        >
                            Difficulty-level name can contain
                            only letters, spaces and hyphens.
                        </p>
                    </div>

                    <!-- Actions -->
                    <div class="create-page__actions">
                        <button
                            type="button"
                            class="create-page__button create-page__button--secondary"
                            [disabled]="isSaving"
                            (click)="cancel()"
                        >
                            <i
                                class="fa fa-times-circle"
                                aria-hidden="true"
                            ></i>

                            <span>Cancel</span>
                        </button>

                        <button
                            type="submit"
                            class="create-page__button create-page__button--primary"
                            [disabled]="isSaving"
                        >
                            <span
                                class="create-page__spinner"
                                *ngIf="isSaving"
                                aria-hidden="true"
                            ></span>

                            <svg
                                *ngIf="!isSaving"
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                            >
                                <path
                                    d="M4 4h13l3 3v13H4Z"
                                ></path>

                                <path
                                    d="M8 4v6h8V4"
                                ></path>
                            </svg>

                            <span>
                                {{
                                    isSaving
                                        ? 'Saving...'
                                        : 'Save'
                                }}
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </section>
    </div>
</div>